import { useState } from "react";
import { useTranslation } from "react-i18next";
import HeroConsultoria from "./components/HeroConsultoria";
import FeaturesConsultoria from "./components/FeaturesConsultoria";
import QuoteModal from "@/components/feature/QuoteModal";
import InfoModal from "@/components/feature/InfoModal";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import Navbar from "@/pages/home/components/Navbar";
import InternalCTASection from "@/components/feature/InternalCTASection";
import LandingFooter from "@/components/feature/LandingFooter";
import LanguageTransitionWrapper from "@/components/feature/LanguageTransitionWrapper";

export default function ConsultoriaPage() {
  const { t } = useTranslation("common");
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteService, setQuoteService] = useState<string | undefined>(undefined);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState<string | null>(null);

  const openModal = (type: string) => {
    setModalType(type);
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setTimeout(() => setModalType(null), 300);
  };

  const openQuote = (service?: string) => {
    setQuoteService(service);
    setQuoteOpen(true);
  };
  const closeQuote = () => {
    setQuoteOpen(false);
    setTimeout(() => setQuoteService(undefined), 300);
  };

  return (
    <div className="relative bg-background-950 min-h-screen">
      <Navbar onOpenQuote={openQuote} />

      <LanguageTransitionWrapper>
        <main>
          <HeroConsultoria onOpenQuote={openQuote} />
          <FeaturesConsultoria onOpenModal={openModal} />

          <InternalCTASection
            tag={t("co.cta.tag")}
            title={t("co.cta.title")}
            highlight="Openlab Secure"
            subtitle={t("co.cta.subtitle")}
            buttonLabel={t("co.cta.button")}
            homeButtonLabel={t("co.cta.homeButton")}
            onQuote={() => openQuote("Consultoria de Seguridad")}
            image="https://readdy.ai/api/search-image?query=Business%20consultants%20collaborating%20in%20a%20modern%20glass%20meeting%20room%2C%20friendly%20discussion%20over%20security%20strategy%2C%20warm%20natural%20daylight%2C%20professional%20editorial%20photography%2C%20human%20centered%2C%20soft%20depth%20of%20field&width=1600&height=900&seq=co-cta-human-01&orientation=landscape"
          />
        </main>

        <LandingFooter pageName="Consultoria Estrategica" />
      </LanguageTransitionWrapper>
      <QuoteModal isOpen={quoteOpen} onClose={closeQuote} preselectedService={quoteService} />
      <InfoModal
        isOpen={modalOpen}
        onClose={closeModal}
        modalType={modalType}
        onOpenQuote={(service) => {
          closeModal();
          openQuote(service);
        }}
      />
      <WhatsAppFloat />
    </div>
  );
}